import { render, staticRenderFns } from "./MissingPreviewPlaceholder.vue?vue&type=template&id=0815966e"
import script from "./MissingPreviewPlaceholder.vue?vue&type=script&lang=js"
export * from "./MissingPreviewPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports